import React from 'react';
import * as Yup from 'yup';

import {
  AppForm,
  AppFormField,
  AppFormSubmitButton,
} from '../../../../../components/forms';
import {Column, Row} from '../../../../../components/layout';
import {DataValidationProps} from '../DataValidation';
import './styles.scss';
import Header2 from '../../../../../components/headers/header2';
import * as fonts from '../../../../../util/fonts';
import { colors } from './../../../../../util/colors';

const validationSchema = Yup.object().shape({
  cardNumber: Yup.string(),
  //phone: Yup.string().required().max(13).matches(new RegExp('^[0-9+]+$'), ''),
});



function AddContacts({
  valid,
  setValid,
  addToWizard,
  wizard,
  labels,
  nextStep
}: DataValidationProps) {
  const userContacts =
    wizard?.dataValidation?.currentUser?.email ||
    wizard?.dataValidation?.currentUser?.phone;
  
  const handleNoCard = () => {
    const dataValidation = {
      currentUser: {
        contacts: {
          ...userContacts,
          //phone: values.phone,
        },
      },
      selectedContact: '',
      selectedContactType: 'EMAIL',
      cardNumber: '',
      state: 'NOT_FOUND',
    };

    addToWizard({dataValidation});
    nextStep();
  }

  return (
    <Column className="add-contacts-container">
      <AppForm
        initialValues={{cardNumber: '', phone: ''}}
        validationSchema={validationSchema}
        onValidation={(valid) => setValid(valid)}
        onSubmit={(values) => {
          const dataValidation = {
            currentUser: {
              contacts: {
                ...userContacts,
                //phone: values.phone,
              },
            },
            selectedContact: '',
            selectedContactType: 'EMAIL',
            cardNumber: values.cardNumber,
            state: 'NOT_FOUND',
          };

          addToWizard({dataValidation});
          nextStep();
        }}>
        <Header2 className="title-step2-responsive">
          {labels?.activationChoice_title}
        </Header2>
        <Header2 className="app-center add-contacts-header">
          {labels?.insuranceAndPhone_pageSubTitle}
        </Header2>
        <Row className="add-contacts-row">
          <AppFormField
            name="cardNumber"
            placeholder={labels?.insuranceAndPhone_insuranceNumberPlaceholder}
          />
        </Row>
        <Row className="add-contacts-row app-center">
          <Column>
            <a
              className="add-contacts-didnt-receive-question"
              onClick={handleNoCard}
              href=""
              style={{...fonts.M, color: colors.blue}}>
              {labels?.insuranceAndPhone_didndReceivedText}
            </a>
            {/* <p
              className="add-contacts-didnt-receive-question-text"
              style={{...fonts.M}}>
              {labels?.insuranceAndPhone_didndReceivedText}
            </p> */}
          </Column>
        </Row>
        {/* <hr className="add-contacts-hr" /> */}
        {/* <Row className="add-contacts-row">
          <AppFormField
            name="phone"
            placeholder={labels?.insuranceAndPhone_phoneNumberPlaceholder}
          />
        </Row>
        <Row className="add-contacts-row">
          <p style={{...fonts.M}}>{labels?.insuranceAndPhone_sendCodeText}</p>
        </Row> */}
        <Row className="insurance-validation-continue-button-row">
          <AppFormSubmitButton
            title={labels?.insuranceAndPhone_confirmButtonText}
            disabled={!valid}
            className="stepper-continue-button"
          />
        </Row>
      </AppForm>
    </Column>
  );
}

export default AddContacts;
